import { Middleware } from '@reduxjs/toolkit';

import { initiateNewTransaction } from '@cashier/cashier-data-access';
import { PaymentStates } from '@cashier/cashier-model';
import { eventBus, EventFactory } from '@cashier/cashier-shared';

export const paymentInfoMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);
    const {
      paymentProcessing,
      paymentInfo: { paymentInfo },
    } = store.getState();

    const forbidToSendGetBackPostMessage = [
      PaymentStates.CANCELLED,
      PaymentStates.FAILED,
    ].includes(paymentInfo?.state);

    if (
      action.type === initiateNewTransaction.toString() &&
      !paymentProcessing?.error &&
      !forbidToSendGetBackPostMessage
    ) {
      eventBus.emit(EventFactory.getBackToPaymentMethods());
    }

    return result;
  };
